import React, { ReactNode, useEffect } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { GlobalsTools } from '@shared/types';

import { DesignSystemProvider } from './DesignSystemProvider';
import { GlobalsProvider } from '../../shared/contexts/GlobalsContext';
import { AIAssistantProvider } from '../../shared/contexts/AIAssistantContext';
import { CHARGEBEE_SITE } from '../../constants';

import type { RootState } from '../../reducers';

interface AppProvidersProps {
  store: Store<RootState>;
  tools: GlobalsTools;
  children: ReactNode;
}

export function AppProviders({ store, tools, children }: AppProvidersProps) {
  const { queryClient } = tools;

  useEffect(() => {
    if (CHARGEBEE_SITE && window.Chargebee?.init) {
      window.Chargebee.init({
        site: CHARGEBEE_SITE,
      });
    }
  }, [CHARGEBEE_SITE]);

  return (
    <GlobalsProvider tools={tools}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <AIAssistantProvider>
            <DesignSystemProvider children={children} />
          </AIAssistantProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </GlobalsProvider>
  );
}
